import styled from "styled-components"

export const P = styled.p`
  color: ${(props) => props.theme.colors.content.text};
  font-size: 0.8rem;
  margin: 0;
  padding: 0;
  font-weight: 700;
`
export const A = styled.a`
  font-family: ${(props) => props.theme.fonts.body.family}, sans-serif;
  color: ${(props) => props.theme.colors.content.text};
  text-decoration: none;
`
